export default "__VITE_ASSET__2b55d429__"